import { Link } from "react-router-dom";

export default function NavMyMedia({ currentPage = "" }) {
  return (
    <ul className="nav nav-tabs justify-content-center justify-content-sm-start mb-4 border-bottom">
      <li className="nav-item">
        <Link
          to="/my-media"
          className={`nav-link ${
            currentPage === "my-media" ? "active" : ""
          }`}
        >
          <i className="fi fi-rr-picture me-2"></i>
          <span className="d-none d-md-inline-block">My Media</span>
        </Link>
      </li>

      <li className="nav-item">
        <Link
          to="/my-canva"
          className={`nav-link ${
            currentPage === "my-canva" ? "active" : ""
          }`}
        >
          <img src="assets/img/canva.svg" alt="Canva" height="24" style={{ 'filter': 'grayscale(1)'}} />
        </Link>
      </li>

    </ul>
  );
}